var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Twitter"),React.createElement("path",{"fillRule":"nonzero","d":"M9.43 24.75c11.33 0 17.52-9.52 17.52-17.78 0-.27 0-.54-.02-.8 1.2-.9 2.24-1.99 3.07-3.24-1.12.5-2.32.83-3.54.98 1.29-.78 2.25-2.01 2.71-3.46-1.2.73-2.53 1.24-3.9 1.52a6.1 6.1 0 00-7.4-1.23 6.29 6.29 0 00-3.1 6.93A17.39 17.39 0 012.1 1.14a6.31 6.31 0 001.9 8.34A6.04 6.04 0 011.2 8.7v.08a6.23 6.23 0 004.94 6.13c-.9.25-1.86.28-2.78.1a6.17 6.17 0 005.75 4.34A12.23 12.23 0 010 21.95a17.23 17.23 0 009.43 2.8","key":1})]);
}

Twitter.defaultProps = {"fill":"#1DA1F2","viewBox":"0 0 30 25"};

module.exports = Twitter;

Twitter.default = Twitter;
